var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location_box"},[_c('div',{staticClass:"location col-12"},[_vm._v(" "+_vm._s(_vm.step1)+" "),_c('span',{staticClass:"location_arrow"}),_c('span',{staticClass:"step2"},[_vm._v(_vm._s(_vm.step2))])])])}
var staticRenderFns = []

export { render, staticRenderFns }